import {
    EPayFacType,
    ETermsType,
    IConfiguredPaymentProviders,
    TSwiipeService,
    getDistinct,
    getTermsForPayFacs,
    hasValue,
} from "swiipe.portal.shared"

const getServiceTermsMapping: (configuredProviders?: IConfiguredPaymentProviders) => {
    [serviceType in TSwiipeService]: ETermsType[]
} = (configuredProviders?: IConfiguredPaymentProviders) => ({
    AcquiringClearhaus: ["TermsAcquiringClearhaus"],
    PayFaqDigiteal: ["TermsPayFaqDigiteal"],
    AccountToAccount: ["TermsA2a"],
    AnywhereMobile: ["TermsAnywhereMobile"],
    ApplePay: ["TermsApplePay"],
    Checkout: [],
    CreditCard: [],
    Dankort: ["TermsDankort"],
    ExternalAnalytics: ["TermsExternalAnalytics"],
    Forbrugsforeningen: ["TermsForbrugsforeningen"],
    KlarnaFinancing: ["TermsKlarna"],
    KlarnaPayLater: ["TermsKlarna"],
    MobilePayOnline: ["TermsMobilePayOnline"],
    PlusSell: ["TermsPlusSell"],
    ResursInvoice: ["TermsResurs"],
    ResursPartPayment: ["TermsResurs"],
    ResursRevolvingCredit: ["TermsResurs"],
    ReturnSell: ["TermsReturnSell"],
    Swish: ["TermsSwish"],
    Viabill: ["TermsViaBill"],
    Anyday: ["TermsAnyday"],
    Bancontact: ["TermsBancontact"],
    Ideal: ["TermsIdeal"],
    Vipps: [configuredProviders?.Vipps === "VippsMobilePay" ? "TermsVippsEpayment" : "TermsVippsPsp"],
    Winback: ["TermsWinBack"],
    TermsTech: ["TermsTermsTech"],
})

const servicesRequiringAcquiring: TSwiipeService[] = ["CreditCard", "MobilePayOnline", "ApplePay", "Bancontact", "Ideal"]

export function getTermsForSwiipeService(
    service: TSwiipeService,
    payFacType: EPayFacType,
    configuredProviders: IConfiguredPaymentProviders | undefined
) {
    // TODO: Refactor in the future when splitting PSP, Acquiring, and Creditcards
    const acquiringTerms: ETermsType[] = servicesRequiringAcquiring.includes(service) ? getTermsForPayFacs([payFacType]) : []
    return getDistinct([...getServiceTermsMapping(configuredProviders)[service], ...acquiringTerms])
}

export function getTermsForSwiipeServices(
    services: TSwiipeService[],
    configuredProviders: IConfiguredPaymentProviders | undefined
) {
    return getDistinct(services.map((s) => getServiceTermsMapping(configuredProviders)[s].filter(hasValue)).flat())
}
